export enum ENUM__generation_status {
  ADJUSTING = 'ADJUSTING',
  IN_PROGRESS = 'IN_PROGRESS',
  STOPPED = 'STOPPED',
  ERROR = 'ERROR',
  LOCKED = 'LOCKED',
}
